function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e1e1c;}.cls-2{fill:#1b1b1b;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M30.3,39.68a1,1,0,0,1-1-1V35.74c0-3.07,2.34-4.39,4.41-5.57,2.43-1.37,4.72-2.66,4.72-6.5,0-4.43-3.53-7.78-8.21-7.78-8,0-8.16,7.75-8.17,8.08a1,1,0,0,1-1,1,1,1,0,0,1-1-1,12.28,12.28,0,0,1,1.26-5c1.17-2.32,3.66-5.09,8.91-5.09,5.82,0,10.21,4.21,10.21,9.78,0,5-3.18,6.8-5.73,8.25-2.17,1.23-3.4,2-3.4,3.82v2.94A1,1,0,0,1,30.3,39.68Z",
  transform: "translate(-6.19 -5.49)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 24.05,
  cy: 38.78,
  r: 1.92
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M30.24,53.59A24.05,24.05,0,1,1,54.29,29.54,24.08,24.08,0,0,1,30.24,53.59Zm0-46.1a22,22,0,1,0,22.05,22A22.07,22.07,0,0,0,30.24,7.49Z",
  transform: "translate(-6.19 -5.49)"
});

var SvgIconQuestionmark = function SvgIconQuestionmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    viewBox: "0 0 48.1 48.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconQuestionmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_questionmark.a81dbf4e.svg";
export { ForwardRef as ReactComponent };